import { render, staticRenderFns } from "./SourcingFromJobPage.vue?vue&type=template&id=27452c0e"
import script from "./SourcingFromJobPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcingFromJobPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports